import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";

export const actionTypes = {
    UpdateUserProfile: "UPDATE_USER_PROFILE",
    ResetUserProfile: "RESET_USER_PROFILE",
};

const initialUserProfileState = {
    id: 0,
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    location: "",
    roles: "",
    imageUrl: "",
};

export const reducer = (state = initialUserProfileState, action) => {

    switch (action.type) {
        case actionTypes.UpdateUserProfile: {
            return action.payload;
        }

        case actionTypes.ResetUserProfile: {
            return initialUserProfileState;
        }

        default:
            return state;
    }
};

export const actions = {
    updateUserProfile: (model) => ({ type: actionTypes.UpdateUserProfile, payload: model }),
    resetResetProfile: () => ({ type: actions.ResetUserProfile })
};
